import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRoute, hashHistory, IndexRedirect } from 'react-router'
import Root from './components/root'
import Login from './components/login'
import { Provider } from 'react-redux';
import configureStore from './configure-store';
import { getAuthToken, saveAuthTokenFromQueryString } from './utils/session';
import { getApiUrl } from './utils/network';
import Customer from './components/customer';
import Subscriptions from './components/subscriptions';
import Invoices from './components/invoices';
import ChangePassword from './components/change-password';

function requireAuth(nextState, replace) {
   if (!getAuthToken()) {
      replace({ pathname: '/login' })
   }
}

function noAuth(nextState, replace) {
   if (getAuthToken()) {
      replace({ pathname: '/' })
   }
}

function getTokenValue() {
   var reg = new RegExp('[?&]authToken=([^&#]*)', 'i');
   var string = reg.exec(window.location.href);
   return string ? string[1] : null;
}

window.onerror = function (message, url, line, col, error) {
   try {
      let errorUrl = getApiUrl() + '/error' +
         '?message=' + encodeURIComponent(message) +
         '&url=' + encodeURIComponent(url) +
         '&line=' + encodeURIComponent(line) +
         '&col=' + encodeURIComponent(col) +
         '&error=' + encodeURIComponent(error);

      if(line && col && error) {
         let image = new Image();
         image.src = errorUrl;
      }
   }
   catch(e) {
      console.error("Failed to send error report", e);
   }
};

function renderWidget() {
   var token = getTokenValue();
   if (token !== null) {
      saveAuthTokenFromQueryString(token);
   }
     
   ReactDOM.render(
      <Provider store={configureStore()}>
         <Router history={hashHistory}>
            <Route path='/' component={Root}>
               <IndexRedirect to='/customer'/>
               <Route path='customer' component={Customer} onEnter={requireAuth}/>
               <Route path='subscriptions' component={Subscriptions} onEnter={requireAuth}/>
               <Route path='invoices' component={Invoices} onEnter={requireAuth}/>
               <Route path='changePassword' component={ChangePassword} onEnter={requireAuth}/>
               <Route path='login' component={Login} onEnter={noAuth}/>
            </Route>
         </Router>
      </Provider>,
      document.getElementById('my-pages')
   );
};

if (document.readyState === 'loading') {
   document.addEventListener('DOMContentLoaded', renderWidget);
 } else {
   renderWidget();
 }
